import copy from 'copy-to-clipboard'
import { message } from 'antd'

export default function copyToClipboard(string) {
  copy(string)
  message.success('Text copied 👯‍♂️')
}
